import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './PageHeader.module.css'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: ReactNode
  /** Small figures shown under the title — record counts, queue sizes. */
  meta?: ReactNode
  className?: string
}

export function PageHeader({ title, description, actions, meta, className }: PageHeaderProps) {
  return (
    <header className={cn(styles.header, className)}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {description ? <p className={styles.description}>{description}</p> : null}
        {meta ? <div className={styles.meta}>{meta}</div> : null}
      </div>
      {actions ? (
        <div className={styles.actions} data-print="hide">
          {actions}
        </div>
      ) : null}
    </header>
  )
}
